export function getBrowserLanguage(){
  var nav = window.navigator,
  browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
  i,
  language;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }

  return null;
}


export function deviceOS(){
  let userAgent = navigator.userAgent.toLowerCase();
  if(userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1){
    return "IOS";
  }
  else{
    return "AOS";
  }
}

export function isIOSwithChrome(){
  let userAgent = navigator.userAgent.toLowerCase();
  if(userAgent.indexOf("iphone") > -1 && userAgent.indexOf("safari") > -1 && userAgent.indexOf("crios") > -1){
    return true;
  }
  else{
    return false;
  }
}

export function isAndroidFirefox(){
  let userAgent = navigator.userAgent.toLowerCase();
  if(userAgent.indexOf("iphone") == -1 && userAgent.indexOf("firefox") > -1 ){
    return true;
  }
  else{
    return false;
  }
}

export function checkIsDesktop(){
  let isDesktop = false;
  if (typeof window.orientation == 'undefined') {
    isDesktop = true;
  }
  return isDesktop;
}

export function checkIsIpad(){
  let isIpad = false;
  if (navigator.userAgent.match(/(iPad)/i)) {
    isIpad = true;
  }
  return isIpad;
}




// WEBPACK FOOTER //
// ./src/commonFunction/commonFunction.js